import { render } from "./DailyReportToolBar.vue?vue&type=template&id=54a096ed"
import script from "./DailyReportToolBar.vue?vue&type=script&lang=ts"
export * from "./DailyReportToolBar.vue?vue&type=script&lang=ts"

import "./DailyReportToolBar.vue?vue&type=style&index=0&id=54a096ed&lang=css"
script.render = render

export default script
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QToolbar,QSpace,QBtnDropdown,QBadge,QList,QItem,QItemSection,QCheckbox,QItemLabel,QBtnGroup,QBtn,QSeparator,QField});
